(() => {
  if (window.SIProductCardGalleryLoaded) return;
  window.SIProductCardGalleryLoaded = true;

  const normalize = (value) => {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  const getCard = (element) => {
    return element.closest(".product-item");
  };

  const getSlides = (card) => {
    return Array.from(
      card.querySelectorAll("[data-gallery-slide]")
    );
  };

  const getSlidesByColor = (card, color) => {
    const slides = getSlides(card);

    if (!color) return slides;

    const filtered = slides.filter((slide) => {
      return slide.dataset.galleryColor === color;
    });

    // Se il colore ha più immagini, navighiamo solo quelle.
    // Se ne ha una sola, manteniamo le frecce e usiamo tutte le immagini prodotto.
    return filtered.length > 1 ? filtered : slides;
  };

  const updateArrows = (card, slides) => {
    const previous = card.querySelector("[data-gallery-prev]");
    const next = card.querySelector("[data-gallery-next]");

    const hide = slides.length <= 1;

    if (previous) previous.hidden = hide;
    if (next) next.hidden = hide;
  };

  const showSlide = (card, color, index) => {
    const allSlides = getSlides(card);
    const slides = getSlidesByColor(card, color);

    if (!slides.length) return;

    const normalizedIndex =
      ((index % slides.length) + slides.length) %
      slides.length;

    const activeSlide = slides[normalizedIndex];

    allSlides.forEach((slide) => {
      const active = slide === activeSlide;

      slide.hidden = !active;
      slide.classList.toggle("is-active", active);
    });

    card.dataset.galleryColor =
      color || activeSlide.dataset.galleryColor || "";

    card.dataset.galleryIndex =
      normalizedIndex.toString();

    updateArrows(card, slides);
  };

  const selectColor = (card, color) => {
    const normalizedColor = normalize(color);
    const allSlides = getSlides(card);

    const matchingSlides = allSlides.filter((slide) => {
      return slide.dataset.galleryColor === normalizedColor;
    });

    if (!matchingSlides.length) return;

    // Se esistono più immagini dello stesso colore, partiamo dalla prima e restiamo nel gruppo.
    if (matchingSlides.length > 1) {
      showSlide(card, normalizedColor, 0);
      return;
    }

    // Se il colore ha una sola immagine, mostriamo quella e poi consentiamo di scorrere tutte le immagini.
    const absoluteIndex = allSlides.indexOf(matchingSlides[0]);
    showSlide(card, "", absoluteIndex);
  };

  const changeSlide = (card, direction) => {
    const color =
      card.dataset.galleryColor || "";

    const slides =
      getSlidesByColor(card, color);

    if (!slides.length) return;

    const currentIndex =
      parseInt(card.dataset.galleryIndex || "0", 10);

    showSlide(
      card,
      color,
      currentIndex + direction
    );
  };


  /*
   * CLICK SWATCH
   */

  document.addEventListener(
    "click",
    (event) => {

      const swatch = event.target.closest(
        ".product-swatches-options__item[data-gallery-color]"
      );

      if (!swatch) return;

      const card = getCard(swatch);

      if (!card) return;

      const color =
        swatch.dataset.galleryColor;

      selectColor(card, color);

      card
        .querySelectorAll(
          ".product-swatches-options__item[data-gallery-color]"
        )
        .forEach((item) => {
          item.classList.toggle(
            "is-gallery-selected",
            item === swatch
          );
        });
    },
    true
  );


  /*
   * FRECCE
   */

  document.addEventListener(
    "click",
    (event) => {

      const previous =
        event.target.closest("[data-gallery-prev]");

      const next =
        event.target.closest("[data-gallery-next]");

      if (!previous && !next) return;

      const button = previous || next;

      const card = getCard(button);

      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      changeSlide(
        card,
        previous ? -1 : 1
      );
    },
    true
  );


  /*
   * ACCESSIBILITÀ SWATCH
   */

  document.addEventListener(
    "keydown",
    (event) => {

      const swatch = event.target.closest(
        ".product-swatches-options__item[data-gallery-color]"
      );

      if (!swatch) return;

      if (
        event.key !== "Enter" &&
        event.key !== " "
      ) {
        return;
      }

      event.preventDefault();

      swatch.click();
    }
  );


  /*
   * SWIPE MOBILE
   */

  let startX = null;
  let startY = null;
  let activeCard = null;

  document.addEventListener(
    "touchstart",
    (event) => {

      const gallery =
        event.target.closest(
          "[data-product-card-gallery]"
        );

      if (!gallery) return;

      activeCard = getCard(gallery);

      startX =
        event.touches[0].clientX;

      startY =
        event.touches[0].clientY;

      /*
       * Evita che il carousel esterno
       * intercetti immediatamente lo swipe.
       */
      event.stopPropagation();
    },
    {
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    "touchend",
    (event) => {

      if (
        startX === null ||
        startY === null ||
        !activeCard
      ) {
        return;
      }

      const endX =
        event.changedTouches[0].clientX;

      const endY =
        event.changedTouches[0].clientY;

      const deltaX = endX - startX;
      const deltaY = endY - startY;

      /*
       * Swipe orizzontale reale.
       * Il movimento verticale continua
       * a comportarsi come scroll pagina.
       */
      if (
        Math.abs(deltaX) > 35 &&
        Math.abs(deltaX) >
          Math.abs(deltaY)
      ) {
        changeSlide(
          activeCard,
          deltaX < 0 ? 1 : -1
        );
      }

      startX = null;
      startY = null;
      activeCard = null;
    },
    {
      passive: true,
      capture: true
    }
  );


  /*
   * INIZIALIZZAZIONE
   */

  const initialize = (root = document) => {

    root
      .querySelectorAll(
        "[data-product-card-gallery]"
      )
      .forEach((gallery) => {

        const card = getCard(gallery);

        if (!card) return;

        const active =
          card.querySelector(
            "[data-gallery-slide].is-active"
          );

        const color =
          active
            ? active.dataset.galleryColor
            : "";

        showSlide(card, color, 0);
      });
  };

  document.addEventListener(
    "DOMContentLoaded",
    () => initialize()
  );

  document.addEventListener(
    "shopify:section:load",
    (event) => initialize(event.target)
  );

})();